var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClosePopupGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.35742,
    y: 0.880859,
    width: 24.4444,
    height: 2.22222,
    transform: "rotate(45 2.35742 0.880859)",
    fill: "#D3D6DA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6426,
    y: 2.45215,
    width: 24.4444,
    height: 2.22222,
    transform: "rotate(135 19.6426 2.45215)",
    fill: "#D3D6DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClosePopupGray);
export default __webpack_public_path__ + "static/media/icon_close_popup_gray.583d1337c28d95c072a152047bfdca87.svg";
export { ForwardRef as ReactComponent };